import { render, staticRenderFns } from "./modalNotificacao.vue?vue&type=template&id=7e3b41d8&"
import script from "./modalNotificacao.vue?vue&type=script&lang=js&"
export * from "./modalNotificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports